// extracted by mini-css-extract-plugin
export default {"selected-pic":"Exhibition_selected-pic__eTbOj","unselected-pic":"Exhibition_unselected-pic__Tpi8O","indicator":"Exhibition_indicator__3P13z","arrow":"Exhibition_arrow__8vACa"};